import { ErrorOutline } from "@mui/icons-material";
import { Skeleton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DateComponent, DateVariant } from "components/base/DateComponent";
import { useRef } from "react";
import { useRateAgreementById } from "./hooks/useRateAgreementById";

const useStyles = makeStyles({
  "@keyframes fadeIn": {
    from: { opacity: 0 },
    to: { opacity: 1 }
  },
  fadeIn: {
    animation: "$fadeIn 1s ease-in"
  },
  dates: {
    fontSize: "0.8em",
    opacity: 0.65,
    marginLeft: 4
  }
});

interface RateTableNameProps {
  agreementId: string;
  tableId: string;
}

export default function RateTableName({
  agreementId,
  tableId
}: RateTableNameProps) {
  const classes = useStyles();
  const { rateAgreement, loading, error } = useRateAgreementById(agreementId);
  // Track whether data was absent on first render — only animate async fetches.
  const wasLoadingOnMount = useRef(rateAgreement == null);
  if (error) return <ErrorOutline color="secondary" />;
  if (loading) return <Skeleton variant="text" width={140} />;

  const rateTable = rateAgreement?.rateTables.find(rt => rt.id === tableId);
  if (!rateTable) {
    return <div data-testid="rate-table-nav">{tableId}</div>;
  }

  return (
    <div
      data-testid="rate-table-nav"
      className={wasLoadingOnMount.current ? classes.fadeIn : undefined}
    >
      {rateTable.type}
      <span className={classes.dates}>
        (
        <DateComponent date={rateTable.validFrom} variant={DateVariant.SHORT} />
        {"\u2013"}
        <DateComponent date={rateTable.validTo} variant={DateVariant.SHORT} />)
      </span>
    </div>
  );
}
